/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Restart_ConfirmInputs */

const en_us2_plan_build_restart_confirm = /** @type {(inputs: Plan_Build_Restart_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start over today`)
};

const pt_br2_plan_build_restart_confirm = /** @type {(inputs: Plan_Build_Restart_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomeçar hoje`)
};

const es_419_plan_build_restart_confirm = /** @type {(inputs: Plan_Build_Restart_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empezar de nuevo hoy`)
};

const pt_pt2_plan_build_restart_confirm = /** @type {(inputs: Plan_Build_Restart_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recomeçar hoje`)
};

const fr_fr2_plan_build_restart_confirm = /** @type {(inputs: Plan_Build_Restart_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommencer aujourd'hui`)
};

const de_de2_plan_build_restart_confirm = /** @type {(inputs: Plan_Build_Restart_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heute neu starten`)
};

const it_it2_plan_build_restart_confirm = /** @type {(inputs: Plan_Build_Restart_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricomincia oggi`)
};

/**
* | output |
* | --- |
* | "Start over today" |
*
* @param {Plan_Build_Restart_ConfirmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_restart_confirm = /** @type {((inputs?: Plan_Build_Restart_ConfirmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Restart_ConfirmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_restart_confirm(inputs)
	if (locale === "es-419") return es_419_plan_build_restart_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_restart_confirm(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_restart_confirm(inputs)
	if (locale === "de-DE") return de_de2_plan_build_restart_confirm(inputs)
	if (locale === "it-IT") return it_it2_plan_build_restart_confirm(inputs)
	return en_us2_plan_build_restart_confirm(inputs)
});
export { plan_build_restart_confirm as "plan-build.restart_confirm" }